var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 6.1875C9.75 5.77329 9.41422 5.4375 9 5.4375C8.58579 5.4375 8.25 5.77329 8.25 6.1875H9.75ZM6.9543 11.014C6.67015 11.3154 6.68412 11.79 6.9855 12.0742C7.28689 12.3583 7.76156 12.3444 8.0457 12.043L6.9543 11.014ZM8.45521 10.5153L7.90951 10.0008L8.45521 10.5153ZM8.25 6.1875V9.14334H9.75V6.1875H8.25ZM8.0457 12.043L9.00092 11.0298L7.90951 10.0008L6.9543 11.014L8.0457 12.043ZM15.75 9.1875C15.75 12.9154 12.7279 15.9375 9 15.9375V17.4375C13.5563 17.4375 17.25 13.7438 17.25 9.1875H15.75ZM9 15.9375C5.27208 15.9375 2.25 12.9154 2.25 9.1875H0.75C0.75 13.7438 4.44365 17.4375 9 17.4375V15.9375ZM2.25 9.1875C2.25 5.45958 5.27208 2.4375 9 2.4375V0.9375C4.44365 0.9375 0.75 4.63115 0.75 9.1875H2.25ZM9 2.4375C12.7279 2.4375 15.75 5.45958 15.75 9.1875H17.25C17.25 4.63115 13.5563 0.9375 9 0.9375V2.4375ZM8.25 9.14334C8.25 9.46214 8.1282 9.76888 7.90951 10.0008L9.00092 11.0298C9.48204 10.5195 9.75 9.84469 9.75 9.14334H8.25Z",
    fill: "#3E3F47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.3a41ea635c754e6566e1482152a50047.svg";
export { ForwardRef as ReactComponent };